import styled from 'styled-components';
import BaseChart from '@components/common/Charts/BaseChart';
import { ellipsis } from 'polished';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  .ellipsis {
    ${ellipsis()};
  }
  .error-table {
    .value {
      max-width: 400px;
      vertical-align: top;
      white-space: normal;
      padding-right: 8px;
    }
  }
`;

export const StyledBaseChart = styled(BaseChart)`
  width: 100%;
  height: 60px;
`;
